// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"4fe54736","703":"12c4a5a0","787":"6bb3675b"}[chunkId] + ".chunk.js";
};